// Example of creating a MUI dialog modal for adding a payment
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { PaymentOptions } from "../Accounts/Account/Utlis";
import { CustomersAutoComplete } from "../AutoComplete/Customers";

export const CreateNewPaymentModal = ({ open, columns, onClose, onSubmit }) => {
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [amountPaid, setAmountPaid] = useState();

   useEffect(() => {
      setSelectedCustomer("");
      setPaymentMode("");
      setAmountPaid("");
    }, [open]);

  const handleModalSubmit = (event) => {
    event.preventDefault(); // Prevent default form submission

    // Call the onSubmit function with the values parameter
    console.log(selectedCustomer, paymentMode, amountPaid);
    onSubmit({ selectedCustomer, paymentMode, amountPaid });
    onClose();
  };

  const paymentModeOptions = Object.keys(PaymentOptions).map((key) => ({
    value: PaymentOptions[key],
    label: key,
  }));

  // PaymentOptions

  return (
    <>
      <Dialog open={open}>
        <DialogTitle textAlign="center">Payment</DialogTitle>
        <DialogContent>
          <form onSubmit={handleModalSubmit}>
            <Stack
              sx={{
                width: "100%",
                minWidth: { xs: "350px", sm: "500px", md: "400px" },
                gap: "1.5rem",
              }}
            >
              <Box>
                <label>Selected Customer</label>
                {/* <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={customersOption}
                    sx={{
                      minWidth: 200,
                      display: "flex",
                    }}
                    value={values.selectedCustomer}
                    onChange={handleSelectCustomer}
                    renderInput={(params) => <TextField {...params} />}
                  /> */}
                <CustomersAutoComplete
                  value={selectedCustomer}
                  onChange={(e, newValue) => setSelectedCustomer(newValue)}
                />
              </Box>
              {/* <Grid container sx={{ justifyContent: "space-around" }}>
                  <label>Arrears</label>
                  <label>500</label>
                </Grid> */}
              <Box>
                <label>Payment Mode</label>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo3"
                  options={paymentModeOptions}
                  sx={{
                    minWidth: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  renderInput={(params) => <TextField {...params} />}
                  value={paymentMode}
                  onChange={(event, newValue) => setPaymentMode(newValue)}
                />
              </Box>
              <Box>
                <label>Amount Paid</label>
                <TextField
                  type="number"
                  sx={{ minWidth: "100%" }}
                  value={amountPaid}
                  onChange={(e) => setAmountPaid(e.target.value)}
                />
              </Box>
            </Stack>
          </form>
        </DialogContent>
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            color="secondary"
            onClick={handleModalSubmit}
            variant="contained"
            disabled={
              selectedCustomer === "" ||
              paymentMode === "" ||
              amountPaid === "" ||
              Number(amountPaid) <= 0
            }
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
